import React from 'react';

import Image from '../Image';

import SC from './partnerElements';

const PartnerCard = ({ partner }) => {
  return (
    <SC.PartnerCard key={partner.id}>
      <a href={`discover/partner/${partner.slug}`}>
        <SC.StyledCard className="featured-card">
          <Image
            alt={partner.name}
            src={partner?.imgUrls.logo}
            width={131}
            height={131}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw,33vw"
          />
        </SC.StyledCard>
      </a>
    </SC.PartnerCard>
  );
};

export default PartnerCard;
export { SC };
